import type { GetServerSidePropsContext } from 'next';
import { useConfig } from 'shared/config/ConfigContext';
import { Head } from 'shared/page/Head';
import { FavoriteApiProvider } from '@/context/FavoriteApiProvider';
import type { DeviceType } from '@/domain';
import ResultMap from '@/scenes/resultPage/containers/resultMap/ResultMap';
import { clientConfig } from '@/server/config';
import { buildCommonProps, sanitizeCommonProps } from '@/server/data/';

interface MapPageProps {
    loginId?: number;
    deviceType?: DeviceType;
    [key: string]: unknown;
}

const MapPage = (props: MapPageProps) => {
    const { baseUrl } = useConfig();

    return (
        <>
            <Head
                title="Feriehjem og hytter - sammenlign pris | FINN reise"
                description="Finn tusenvis av feriehjem og hytter på et sted!"
                canonical={`${baseUrl}/reise/feriehus-hytteutleie/kart/`}
            />
            <main>
                <FavoriteApiProvider loginId={props.loginId}>
                    {/* @ts-expect-error ResultMap HOC props typing */}
                    <ResultMap {...props} />
                </FavoriteApiProvider>
            </main>
        </>
    );
};

export const getServerSideProps = async ({ req, res, query }: GetServerSidePropsContext) => {
    const commonProps = await buildCommonProps(req, res, query);

    return {
        props: {
            config: clientConfig,
            ...sanitizeCommonProps(commonProps),
        },
    };
};
export default MapPage;
